import React from "react";
import PageHeader from "../../../../components/common/PageHeader";
import SearchBar from "../../../../components/common/SearchBar";
import ExportMenu from "./ExportMenu";

/**
 * Header component for Product Availability page
 * Contains title, search bar, and export dropdown menu
 */
const ProductAvailabilityHeader = ({
  searchQuery,
  onSearchChange,
  onExportClick,
  onExportClose,
  onExportPDF,
  onExportCSV,
  anchorEl,
}) => {
  return (
    <PageHeader
      showBackButton={true}
      backTo={-1}
      title="Product Availability"
      subtitle={
        <span className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 bg-blue-500 rounded-full"></span>
          View product status and availability
        </span>
      }
      action={
        <div className="relative">
          <button
            onClick={onExportClick}
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            Export
          </button>

          {/* Export Menu Dropdown */}
          <ExportMenu
            anchorEl={anchorEl}
            onClose={onExportClose}
            onExportPDF={onExportPDF}
            onExportCSV={onExportCSV}
          />
        </div>
      }
      search={
        <SearchBar
          value={searchQuery}
          onChange={onSearchChange}
          placeholder="Search products..."
          className="max-w-lg"
        />
      }
    />
  );
};

export default ProductAvailabilityHeader;
